import React, { Component } from "react";
import { NavLink, HashRouter, Route } from "react-router-dom";
import Home from "./Home";
import Namasankeerthanam from "./Namasankeerthanam";
import ProgramAndEvents from "./ProgramAndEvents";
import Downloads from "./Downloads";
import ContactUs from "./ContactUs";
import Photos from "./Photos";

import "../js/loader.js";
import "../js/appConstants.js";
import "../js/youtube-videos.js";

const links = [
  { to: "/", label: "Home", exact: true },
  { to: "/Namasankeerthanam", label: "Namasankeerthanam" },
  { to: "/ProgramAndEvents", label: "Programs & Events" },
  { to: "/Downloads", label: "Music" },
  { to: "/Photos", label: "Photos" },
  { to: "/ContactUs", label: "Contact" }
];

export default class Main extends Component {
  state = { menuOpen: false };

  constructor(props) {
    super(props);
    window.clickLog("load", "homepage");
  }

  closeMenu = () => this.setState({ menuOpen: false });

  renderLinks() {
    return links.map(({ to, label, exact }) => (
      <NavLink key={to} exact={exact} to={to} onClick={this.closeMenu}>
        {label}
      </NavLink>
    ));
  }

  render() {
    const { menuOpen } = this.state;

    return (
      <HashRouter>
        <div className="site-shell">
          <header className="site-header">
            <div className="site-header__inner">
              <NavLink exact to="/" className="brand" onClick={this.closeMenu} aria-label="RadhaKrishna Sankeerthana Samajam home">
                <span className="brand__mark" aria-hidden="true">ॐ</span>
                <span>
                  <span className="brand__text">RadhaKrishna Sankeerthana Samajam</span>
                  <span className="brand__subtext">Bhajans · Sathsangam · Tradition</span>
                </span>
              </NavLink>
              <nav className="site-nav" aria-label="Primary navigation">{this.renderLinks()}</nav>
              <button type="button" className="menu-toggle" aria-expanded={menuOpen} aria-controls="mobile-navigation" aria-label="Toggle navigation" onClick={() => this.setState({ menuOpen: !menuOpen })}>☰</button>
            </div>
            <nav id="mobile-navigation" className={`mobile-nav ${menuOpen ? "is-open" : ""}`} aria-label="Mobile navigation">{this.renderLinks()}</nav>
          </header>
          <main className="page-content">
            <Route exact path="/" component={Home} />
            <Route path="/Namasankeerthanam" component={Namasankeerthanam} />
            <Route path="/ProgramAndEvents" component={ProgramAndEvents} />
            <Route path="/Downloads" component={Downloads} />
            <Route path="/ContactUs" component={ContactUs} />
            <Route path="/Photos" component={Photos} />
          </main>
        </div>
      </HashRouter>
    );
  }
}
